import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Pages
import EmployeeLogin from "./pages/EmployeeLogin";
import EmployeeSurvey from "./pages/EmployeeSurvey";
import SurveyComplete from "./pages/SurveyComplete";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import EmployeeMaster from "./pages/EmployeeMaster";
import SurveyBuilder from "./pages/SurveyBuilder";
import Analytics from "./pages/Analytics";
import ActionTracker from "./pages/ActionTracker";
import UserManagement from "./pages/UserManagement";
import Methodology from "./pages/Methodology";
import ForgotPassword from "./pages/ForgotPassword";
import ChangePassword from "./pages/ChangePassword";

// Context
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Employee Survey Portal */}
          <Route path="/" element={<EmployeeLogin />} />
          <Route path="/survey" element={
            <ProtectedRoute type="employee">
              <EmployeeSurvey />
            </ProtectedRoute>
          } />
          <Route path="/survey/complete" element={<SurveyComplete />} />

          {/* Admin Portal */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/change-password" element={
            <ProtectedRoute type="admin">
              <ChangePassword />
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute type="admin">
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/employees" element={
            <ProtectedRoute type="admin">
              <EmployeeMaster />
            </ProtectedRoute>
          } />
          <Route path="/admin/surveys" element={
            <ProtectedRoute type="admin">
              <SurveyBuilder />
            </ProtectedRoute>
          } />
          <Route path="/admin/analytics" element={
            <ProtectedRoute type="admin">
              <Analytics />
            </ProtectedRoute>
          } />
          <Route path="/admin/actions" element={
            <ProtectedRoute type="admin">
              <ActionTracker />
            </ProtectedRoute>
          } />
          <Route path="/admin/users" element={
            <ProtectedRoute type="admin" requireSuperAdmin>
              <UserManagement />
            </ProtectedRoute>
          } />
          <Route path="/admin/methodology" element={
            <ProtectedRoute type="admin">
              <Methodology />
            </ProtectedRoute>
          } />

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
